import AlbumOutlinedIcon from '@mui/icons-material/AlbumOutlined';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CallSplitOutlinedIcon from '@mui/icons-material/CallSplitOutlined';
import { Box, Button, Tooltip, Typography } from '@mui/material';

type ProposalMenuButtonProps = {
  isInProposal: boolean;
  title: string | undefined;
  proposalName: string | undefined;
  loading: boolean;
  isMenuOpen: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const ProposalMenuButton: React.FC<ProposalMenuButtonProps> = ({
  isInProposal,
  title,
  proposalName,
  loading,
  isMenuOpen,
  onClick
}) => {
  const buttonText = isInProposal ? proposalName : title;
  const tooltipTitle = isInProposal && title ? `Proposal Name: ${proposalName}\nProject name: ${title}` : title;

  return (
    <Tooltip
      title={tooltipTitle}
      slotProps={{
        tooltip: {
          sx: { whiteSpace: 'pre-line' }
        }
      }}
    >
      <Box
        component='span'
        color={isInProposal ? 'info.main' : 'text.primary'}
        sx={{ flex: '0 1 auto', minWidth: 0, overflow: 'hidden', display: 'inline-flex' }}
      >
        <Button
          color='inherit'
          variant={isInProposal ? 'outlined' : 'text'}
          onClick={onClick}
          sx={{ ml: 2, minWidth: 0, maxWidth: '100%' }}
          startIcon={isInProposal ? <CallSplitOutlinedIcon /> : <AlbumOutlinedIcon />}
          endIcon={
            <ArrowDropDownIcon
              sx={{ transition: 'transform 0.2s ease-in-out', transform: isMenuOpen ? 'rotate(180deg)' : undefined }}
            />
          }
          loading={loading}
          loadingPosition='start'
          aria-controls={isMenuOpen ? 'proposal-menu' : undefined}
          aria-haspopup='true'
          aria-expanded={isMenuOpen ? 'true' : undefined}
          data-testid='proposal-menu-button'
        >
          <Typography noWrap id='area-title'>
            {buttonText}
          </Typography>
        </Button>
      </Box>
    </Tooltip>
  );
};
